/* src/app/pages/statement/statement.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
h1,
h2,
h3,
h4,
h5,
h6,
label,
p,
b,
small,
span,
strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
h1.cds-required::after,
h2.cds-required::after,
h3.cds-required::after,
h4.cds-required::after,
h5.cds-required::after,
h6.cds-required::after,
label.cds-required::after,
p.cds-required::after,
b.cds-required::after,
small.cds-required::after,
span.cds-required::after,
strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
h1[class^=c-],
h2[class^=c-],
h3[class^=c-],
h4[class^=c-],
h5[class^=c-],
h6[class^=c-],
label[class^=c-],
p[class^=c-],
b[class^=c-],
small[class^=c-],
span[class^=c-],
strong[class^=c-] {
  color: var(--color);
}
b,
strong,
span {
  font-family: var(--cds-font-family);
}
h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
p.bold {
  font-weight: bold;
}
label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row {
  grid-template-rows: 80px;
  height: 80px;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .status {
  justify-content: center;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row i.cds-icon-search {
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .value.c-text-medium {
  --color: var(--cds-primary-500);
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .cds-icon-filled-check {
  color: var(--cds-revenue);
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .cds-icon-filled-clock {
  color: var(--cds-text-light);
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .cds-icon-filled-alert-triangle {
  color: var(--cds-danger-400);
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .name {
  line-height: 1.35;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .striped-row .bank_id .bank-details p {
  line-height: 1.35;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list bfm-value-accordion header {
  background: transparent;
  padding: 24px 0px;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .financial-record-accordion header,
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .financial-record-accordion .account-last-value {
  flex-direction: column;
  align-items: flex-end;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .financial-record-accordion header h4,
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .financial-record-accordion .account-last-value h4 {
  --color: var(--cds-text-primary);
  font-weight: 700;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list .financial-record-accordion .group-header {
  margin-top: 32px;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list ul.striped .financial-record-header {
  background-color: var(--cds-foreground-20);
  height: 80px;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list ul.striped .financial-record-header h5 {
  font-weight: 600;
  color: var(--cds-text-strong);
  font-size: 16px;
  line-height: 1.25;
}
:host ::ng-deep bfm-paginated-financial-list .financial-record-list ul.striped bfm-list-item:nth-child(even) {
  background: var(--cds-foreground-20);
}
:host ::ng-deep cds-search-input input {
  padding: 0px 32px;
}
:host ::ng-deep cds-search-input i.cds-icon-search,
:host ::ng-deep cds-search-input i.cds-icon-search.v-compact {
  right: initial;
  left: 4px;
}
.container-statement {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.container-statement .financial-records-container {
  display: flex;
  flex-direction: column;
  background-color: var(--cds-background-main);
  padding: 20px;
  gap: 30px;
}
.container-statement .time-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.container-statement .time-header h3 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: 700;
  color: var(--cds-primary-500);
  line-height: 1;
}
.container-statement .time-header h6 {
  font-size: 12px;
}
.container-statement .search-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 20px;
}
.container-statement .search-row div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
}
.container-statement .search-row div #financial-records-filter-button i {
  color: inherit;
}
.container-statement .search-row div #financial-records-filter-button:not(:disabled) .filter-counter {
  background-color: var(--cds-primary-500);
  color: var(--cds-background-main);
}
.container-statement .search-row div #financial-records-filter-button:not(:disabled):hover .filter-counter {
  background-color: var(--cds-background-main);
  color: var(--cds-primary-500);
}
.container-statement .search-row .filter-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-foreground-10);
  line-height: 1;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--cds-text-light);
}
/*# sourceMappingURL=statement.component.css.map */
